import type { Stop, StopDetails } from '#domain/Stop.ts';

export type TourStatus = 'open' | 'planned' | 'in-transit' | 'finished' | 'problem';

export type TourProblemType =
    | 'other'
    | 'call-back'
    | 'declined-goods'
    | 'problem-with-customer'
    | 'customer-not-available'
    | 'accident'
    | 'heavy-traffic'
    | 'damage'
    | 'running-late';

export type TourProblem = {
    id: string;
    type: TourProblemType;
};

export type TourProgress = {
    totalStopAmount: number;
    finishedStopAmount: number;
};

export type TourCapacity = {
    maxWeightKg?: number;
    maxLoadingMeter?: number;
    maxVolumeLiter?: number;
    maxVolumeCubicMeter?: number;
};

export type Tour = {
    id: string;
    searchName: string;
    note?: string;
    driverId?: string;
    truck: {
        id: string;
        licensePlate?: string;
    };
    trailer: {
        id?: string;
        licensePlate?: string;
    };
    status: TourStatus;
    progress: TourProgress;
    capacity?: TourCapacity;
    firstStop?: Stop;
    lastStop?: Stop;
    problem?: TourProblem;
};

export type TourDetails = Tour & {
    stops: StopDetails[];
};

export const isTourStarted = (tour?: Tour) => {
    return tour?.status === 'in-transit' || tour?.status === 'finished' || tour?.status === 'problem';
};
